/**
 * Typ loaderu
 */
export enum LoaderTheme {
    default = "default",
    colored = "colored",
    light = "light",
    dark = "dark",
}

/**
 * Velikost loaderu
 */
export enum LoaderSize {
    default = "default",
    medium = "medium",
    large = "large",
}
